export default class FiveKwhSwiperTwo {
    constructor({ wrapEl, pcEl, mbEl }){
        this.wrapDOM = document.querySelector(wrapEl)
        this.wrapEl = wrapEl
        this.PCDOM = document.querySelector(pcEl)
        this.MBDOM = document.querySelector(mbEl)
        this.pcEl = pcEl
        this.mbEl = mbEl
        this.curIndex = 0

        // this.videoEndedPlayEvent = this.videoEndedPlayEvent.bind(this)
        this.init = this.init.bind(this)
        if (this.PCDOM && this.MBDOM) {
            this.mobileExpand = this.MBDOM?.dataset?.expand === 'true'
            this.init()
            window.addEventListener('resize', this.init)
        }
        this.tabItems = document.querySelectorAll('[data-tab-item]')
    }
    init() {
        const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
        // 判断当前是 PC 端还是 MB 端
        if (clientWidth < 1024) {
            if (!this.swiperMB) {
                this.MBDOM && this.initMB(); // 初始化移动端的 Swiper
            }
        } else {
            if (!this.swiperPC) {
                this.PCDOM && this.initPC(); // 初始化 PC 端的 Swiper
            }
        }

        $(`${this.wrapEl} .swiper-button-prev`).attr("data-ga-params-current_page", window.location.href);
        $(`${this.wrapEl} .swiper-button-next`).attr("data-ga-params-current_page", window.location.href);
        $(`${this.wrapEl} .slideshow-pagination-item`).attr("data-ga-params-current_page", window.location.href);
        $(`${this.wrapEl} .slideshow-pagination-item`).attr("data-ga-params-title", $(`${this.wrapEl} .five-kwh-content`).data('gatitle'));
    }

    initPC(){
        const { autoplay, delay, size } = this.PCDOM?.dataset;
        this.config = {
            loop: size > 1,
            autoplay: autoplay === 'true',
            autoplayDelay: delay,
        };
        const self = this
        this.swiperPC = new Swiper(this.pcEl,{
            autoplay: this.config.autoplay ? {
                delay: this.config.autoplayDelay * 1000,
                disableOnInteraction: false
            } : false,
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: true,
            loop: this.config.loop,
            observer: true,
            observeParents: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1
            },
            navigation: {
                nextEl: `${this.wrapEl} .swiper-two-pc-button-next`,
                prevEl: `${this.wrapEl} .swiper-two-pc-button-prev`
            },
            pagination: {
                el: `${this.wrapEl} .five-kwh-pagination`,
                clickable: true,
                bulletClass: 'slideshow-pagination-item',
                bulletActiveClass: 'active pagination-active',
                clickableClass: 'slideshow-pagination-clickable',
                modifierClass: 'slideshow-pagination-',
                renderBullet: function (index, className) {
                    let slideIndex = index,
                        number = (index <= 10) ? '0' + (slideIndex + 1) : (slideIndex + 1);

                    let paginationItem = `<span class="slideshow-pagination-item" 
                                data-ga-event="5000plus_page_user_clicks"
                                data-ga-action="click"
                                data-ga-params-current_page=""
                                data-ga-params-module="Picture Display"
                                data-ga-params-title=""
                                data-ga-params-position="Points"
                        data-tab-item >`;
                    paginationItem = (index <= 10) ? paginationItem +
                        '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' :
                        paginationItem;
                    paginationItem += '</span>';
                    return paginationItem;
                },
            },
            on: {
                init: function(){
                    setTimeout(() => {
                        const pcCurrentPlay = `${self.wrapEl} .five-kwh-box`;
                        const autoplayValue = $(pcCurrentPlay).attr('data-videoplay');
                        const curSlide = Array.from(this.slides).filter(it => it.classList.contains('swiper-slide-active'))
                        const curVideo = $(curSlide).find('jky-video')[0]
                        if (autoplayValue === 'true') {
                            self.playVideo('PC', curSlide, curVideo, true)
                        }
                    }, 500);
                },
                slideNextTransitionStart: function(swiper){
                    this.update()
                },
                slidePrevTransitionStart: function(swiper){
                    this.update()
                },
                resize: function () {
                    setTimeout(() => {
                        this.update()
                    }, 500);
                },
                slideChange: function(swiper) {
                    const activeSlide = $(swiper.slides[swiper.activeIndex]);
                    const description = activeSlide.attr('data-description');
                    const subImage = activeSlide.attr('data-subimage');
                    const subImageLink = activeSlide.attr('data-subimagelink');
                    const urlTarget = activeSlide.attr('data-target');
                    const descriptionEl = $(`${self.wrapEl} .five-kwh-active-des`);
                    const subImageEl = $(`${self.wrapEl} .five-kwh-active-image`);
                    const swiperStyle =  $(`${self.wrapEl} .five-kwh-box`).attr('data-swiperstyle');
                    if (swiperStyle === 'style-one') {
                        descriptionEl.html(description || '');
                    } else {
                        if (subImage) {
                            const imageTag = `<img src="${subImage}" alt="Swiper Image">`;
                            const html = subImageLink
                                ? `<a href="${subImageLink}" target="${urlTarget}">${imageTag}</a>`
                                : imageTag;
                            subImageEl.html(html);
                        } else {
                            subImageEl.empty();
                        }
                    }
                },
                slideChangeTransitionStart: function () {
                    // 暂停全部视频
                    this.slides.each(function (slide) {
                        const video = $(slide).find('jky-video')[0]
                        if (video && video.pause) {
                            video.videoInfo.autoplay = false
                            video.pause()
                        }
                    })
                },
                slideChangeTransitionEnd: function () {
                    const curSlide = Array.from(this.slides).filter(it => it.classList.contains('swiper-slide-active'))
                    const pcCurrentPlay = `${self.wrapEl} .five-kwh-box`;
                    const autoplayValue = $(pcCurrentPlay).attr('data-videoplay');
                    const curVideo = $(curSlide).find('jky-video')[0]
                    if (curVideo && autoplayValue === 'true'){
                       self.playVideo('PC', curSlide, curVideo, false)
                    }
                    const curImgs = $(curSlide).find("img");
                    curImgs.each(function() {
                        // 兜底防止白屏
                        if (this) {
                            this.classList.remove("lazyloading");
                            this.classList.add("lazyloaded");
                        }
                    });
                },
            }
        })
        this.checkMp4(this.PCDOM)
    }
    initMB(){
        const { autoplay, delay, size } = this.MBDOM?.dataset;
        this.config = {
            loop: size > 1,
            autoplay: autoplay === 'true',
            autoplayDelay: delay,
        };
        const self = this
        this.swiperMB = new Swiper(this.mbEl,{
            autoplay: this.config.autoplay ? {
                delay: this.config.autoplayDelay * 1000,
                disableOnInteraction: false
            } : false,
            slidesPerView: 'auto',
            loop: this.config.loop,
            observer: true,
            observeParents: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1
            },
            navigation: {
                nextEl: `${this.wrapEl} .swiper-two-mb-button-next`,
                prevEl: `${this.wrapEl} .swiper-two-mb-button-prev`
            },
            pagination: {
                el: `${this.wrapEl} .five-kwh-pagination`,
                clickable: true,
                bulletClass: 'slideshow-pagination-item',
                bulletActiveClass: 'active pagination-active',
                clickableClass: 'slideshow-pagination-clickable',
                modifierClass: 'slideshow-pagination-',
                renderBullet: function (index, className) {
                    let slideIndex = index,
                        number = (index <= 10) ? '0' + (slideIndex + 1) : (slideIndex + 1);

                    let paginationItem = `<span class="slideshow-pagination-item" 
                                data-ga-event="5000plus_page_user_clicks"
                                data-ga-action="click"
                                data-ga-params-current_page=""
                                data-ga-params-module="Picture Display"
                                data-ga-params-title=""
                                data-ga-params-position="Points">`;
                    paginationItem = (index <= 10) ? paginationItem +
                        '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' :
                        paginationItem;
                    paginationItem += '</span>';
                    return paginationItem;
                },
            },
            on: {
                init: function(){
                    setTimeout(() => {
                        const pcCurrentPlay = `${self.wrapEl} .five-kwh-box`;
                        const autoplayValue = $(pcCurrentPlay).attr('data-videoplay');
                        const curSlide = Array.from(this.slides).filter(it => it.classList.contains('swiper-slide-active'))
                        const curVideo = $(curSlide).find('jky-video')[0]
                        if (autoplayValue === 'true') {
                            self.playVideo('MB', curSlide, curVideo, true)
                        }
                    }, 500);
                },
                slideNextTransitionStart: function(swiper){
                    this.update()
                },
                slidePrevTransitionStart: function(swiper){
                    this.update()
                },
                resize: function () {
                    setTimeout(() => {
                        this.update()
                    }, 500);
                },
                slideChange: function(swiper) {
                    const activeSlide = $(swiper.slides[swiper.activeIndex]);
                    const description = activeSlide.attr('data-description');
                    const subImage = activeSlide.attr('data-subimage');
                    const subImageLink = activeSlide.attr('data-subimagelink');
                    const urlTarget = activeSlide.attr('data-target');
                    const descriptionEl = $(`${self.wrapEl} .five-kwh-active-des`);
                    const subImageEl = $(`${self.wrapEl} .five-kwh-active-image`);
                    const swiperStyle =  $(`${self.wrapEl} .five-kwh-box`).attr('data-swiperstyle');
                    if (swiperStyle === 'style-one') {
                        descriptionEl.html(description || '');
                    } else {
                        if (subImage) {
                            const imageTag = `<img src="${subImage}" alt="Swiper Image">`;
                            const html = subImageLink
                                ? `<a href="${subImageLink}" target="${urlTarget}">${imageTag}</a>`
                                : imageTag;
                            subImageEl.html(html);
                        } else {
                            subImageEl.empty();
                        }
                    }
                },
                slideChangeTransitionStart: function () {
                    // 暂停全部视频
                    this.slides.each(function (slide) {
                        const video = $(slide).find('jky-video')[0]
                        if (video && video.pause) {
                            video.videoInfo.autoplay = false
                            video.pause()
                        }
                    })
                },
                slideChangeTransitionEnd: function () {
                    const curSlide = Array.from(this.slides).filter(it => it.classList.contains('swiper-slide-active'))

                    const pcCurrentPlay = `${self.wrapEl} .five-kwh-box`;
                    const autoplayValue = $(pcCurrentPlay).attr('data-videoplay');
                    const curVideo = $(curSlide).find('jky-video')[0]
                    if (curVideo && autoplayValue === 'true'){
                        self.playVideo('MB', curSlide, curVideo, false);
                    }
                    const curImgs = $(curSlide).find("img");
                    curImgs.each(function () {
                        // 兜底防止白屏
                        if (this) {
                            this.classList.remove("lazyloading");
                            this.classList.add("lazyloaded");
                        }
                    });
                },
            }
        })
    }
    playVideo(type, curSlide, curVideo, autoPlay) {
        if (curVideo && curVideo.loadContent) {
            curVideo.videoInfo.autoplay = true
            curVideo.loadContent(false)

            // 如果最初加载失败，尝试重新加载视频
            if (curVideo.querySelector('video').networkState === HTMLMediaElement.NETWORK_NO_SOURCE) {
                curVideo.querySelector('video').load()
            }

            if (this.isAllMp4 && autoPlay) {
                // 监听视频播放完成事件
                curVideo.querySelector('video').addEventListener('ended', this.videoEndedPlayEvent)
            }
        }
    }
    pauseVideo(curVideo) {
        if (curVideo && curVideo.pause) {
            curVideo.videoInfo.autoplay = false
            curVideo.pause()
        }
    }
    // 视频播放完成事件
    videoEndedPlayEvent() {
        return;
        this.curIndex++

        // const videoLoop = $(`${self.wrapEl} .five-kwh-box`).attr('videoloop')
        if (this.swiperPC) {
            this.swiperPC.slideToLoop(this.curIndex, 300, true)

            const curSlide = this.PCDOM.querySelector('.swiper-slide-active')
            const curVideo = $(curSlide).find('jky-video')[0]
            this.playVideo('PC', curSlide, curVideo, true)
        } else {
            this.playVideo('MB', this.jkyVideos[this.curIndex].parentElement, this.jkyVideos[this.curIndex], true)
        }
    }
    checkMp4(DOM) {
        this.jkyVideos = DOM.querySelectorAll('jky-video')

        // 是否都配置的 mp4 格式的视频
        const mp4Video = Array.from(this.jkyVideos).filter(item => item.getAttribute('video-type') === 'mp4')
        this.isAllMp4 = mp4Video.length === this.jkyVideos.length

        this.observe()
    }
    observe() {
        const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

        const Observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Mobile, 播放第一个视频
                    if (clientWidth < 1024) {
                        if (this.curIndex !== this.tabItems.length - 1) {
                            const curSlide = this.mobileExpand ? this.mbEl : this.MBDOM.querySelector('.swiper-slide-active');
                            const index = this.mobileExpand ? this.curIndex : 0;
                            const curVideo = $(curSlide).find('jky-video')[index];

                            // 仅在有视频时调用播放
                            if (curVideo) {
                                this.playVideo('MB', curSlide, curVideo, true);
                            }
                        }
                    } else {
                        // PC, 播放第一个视频
                        if (this.curIndex !== this.tabItems.length - 1) {
                            const curSlide = this.PCDOM.querySelector('.swiper-slide-active');
                            const curVideo = $(curSlide).find('jky-video')[0];

                            // 仅在有视频时调用播放
                            if (curVideo) {
                                this.playVideo('PC', curSlide, curVideo, true);
                            }
                        }
                    }
                } else {
                    // 暂停播放
                    if (clientWidth < 1024) {
                        const curDOM = this.mobileExpand ? this.mbEl : this.MBDOM.querySelector('.swiper-slide-active');
                        const index = this.mobileExpand ? this.curIndex : 0;
                        const curVideo = $(curDOM).find('jky-video')[index];

                        if (curVideo) {
                            this.pauseVideo(curVideo);

                            // if (this.isAllMp4) {
                            //     // 移除当前视频播放完成事件
                            //     curVideo.querySelector('video')?.removeEventListener('ended', this.videoEndedPlayEvent);
                            // }
                        }
                    } else {
                        const curSlide = this.PCDOM.querySelector('.swiper-slide-active');
                        const curVideo = $(curSlide).find('jky-video')[0];

                        if (curVideo) {
                            this.pauseVideo(curVideo);

                            // if (this.isAllMp4) {
                            //     // 移除当前视频播放完成事件
                            //     curVideo.querySelector('video')?.removeEventListener('ended', this.videoEndedPlayEvent);
                            // }
                        }
                    }
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.25,
        });

        // 为每个滑块监听
        this.PCDOM.querySelectorAll('.swiper-slide').forEach(slide => {
            const autoPlay = $(`${self.wrapEl} .five-kwh-box`).attr('videoplay')
            if (autoPlay){
                Observer.observe(slide);
            }
        });
    }
}
